import React, { useState, useEffect } from 'react';
import { config } from '../../data/config';

const AddEditUser = ({ action, data, onSave, onClose, errorFields }) => {
  const [formData, setFormData] = useState({
    id: '',
    firstName: '',
    lastName: '',
    middleName: '',
    sex: 'ж',
    birthDate: '',
    citizenchip: 'Україна',
    birthPlace: '',
    passport__documentNumber__serial: '',
    passport__documentNumber__number: 0,
    passport__issueDate: '',
    passport__authority: '',
    code: '',
    email: '',
    phone: '',
    role: 'kindergartenHead',
    area: 'Київ',
    grant: '',
    isActive: false,
    privelegesAuthType: ''
  });

  const [localState, setLocalState] = useState({
    area: 'Київ',
    role: 'kindergartenHead',
    privelegesAuthType: ''
  });

  const roles_kg = [config.roles[0], config.roles[3], config.roles[4]];

  useEffect(() => {
    if (action === 'edit' && data) {
      setFormData({
        ...data,
        birthDate: data.birthDate ? data.birthDate.split('T')[0] : '',
        passport__issueDate: data.passport__issueDate ? data.passport__issueDate.split('T')[0] : ''
      });
      setLocalState({
        area: data.area,
        role: data.role,
        privelegesAuthType: data.privelegesAuthType || ''
      });
    }
  }, [action, data]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleRoleChange = (e) => {
    const value = e.target.value;
    
    const checkIdentity = (a, b) => 
      (roles_kg.includes(a) && roles_kg.includes(b)) || 
      (!roles_kg.includes(a) && !roles_kg.includes(b));

    const newArea = checkIdentity(value, localState.role) ? localState.area :
      action === 'edit' && checkIdentity(value, data.role) ? data.area :
      !roles_kg.includes(value) ? 'Київ' : '';

    setFormData(prev => ({ ...prev, role: value, area: newArea }));
    setLocalState(prev => ({ ...prev, role: value, area: newArea }));
  };

  const checkError = (field) => errorFields.includes(field);
  const getStyle = (field) => checkError(field) ? { borderColor: 'red' } : {};

  const handleSubmit = () => {
    onSave(formData);
  };

  return (
    <div className="staff-form">
      <div className="form-section">
        
        
        <div className="form-row">
          <div className="form-label">Прізвище</div>
          <div className="form-input">
            <input
              style={getStyle('lastName')}
              value={formData.lastName}
              onChange={(e) => handleInputChange('lastName', e.target.value)}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-label">Ім'я *</div>
          <div className="form-input">
            <input
              style={getStyle('firstName')}
              value={formData.firstName}
              onChange={(e) => handleInputChange('firstName', e.target.value)}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-label">По батькові *</div>
          <div className="form-input">
            <input
              style={getStyle('middleName')}
              value={formData.middleName}
              onChange={(e) => handleInputChange('middleName', e.target.value)}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-label">Стать</div>
          <div className="form-input">
            <select
              style={getStyle('sex')}
              value={formData.sex}
              onChange={(e) => handleInputChange('sex', e.target.value)}
            >
              <option value="ж">Жіноча</option>
              <option value="ч">Чоловіча</option>
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-label">Дата народження</div>
          <div className="form-input">
            <input
              style={getStyle('birthDate')}
              type="date"
              value={formData.birthDate}
              onChange={(e) => handleInputChange('birthDate', e.target.value)}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-label">Громадянство</div>
          <div className="form-input">
            <input
              style={getStyle('citizenchip')}
              value={formData.citizenchip}
              onChange={(e) => handleInputChange('citizenchip', e.target.value)}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-label">Місце народження</div>
          <div className="form-input">
            <input
              style={getStyle('birthPlace')}
              value={formData.birthPlace}
              onChange={(e) => handleInputChange('birthPlace', e.target.value)}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-label">РНОКПП</div>
          <div className="form-input">
            <input
              style={getStyle('code')}
              value={formData.code}
              onChange={(e) => handleInputChange('code', e.target.value)}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-label">Паспорт. Серія</div>
          <div className="form-input">
            <input
              style={getStyle('passport__documentNumber__serial')}
              value={formData.passport__documentNumber__serial}
              onChange={(e) => handleInputChange('passport__documentNumber__serial', e.target.value)}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-label">Паспорт. Номер</div>
          <div className="form-input">
            <input
              style={getStyle('passport__documentNumber__number')}
              type="number"
              value={formData.passport__documentNumber__number}
              onChange={(e) => handleInputChange('passport__documentNumber__number', parseInt(e.target.value) || 0)}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-label">Паспорт. Дата видачі</div>
          <div className="form-input">
            <input
              style={getStyle('passport__issueDate')}
              type="date"
              value={formData.passport__issueDate}
              onChange={(e) => handleInputChange('passport__issueDate', e.target.value)}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-label">Паспорт. Орган, що видав</div>
          <div className="form-input">
            <input
              style={getStyle('passport__authority')}
              value={formData.passport__authority}
              onChange={(e) => handleInputChange('passport__authority', e.target.value)}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-label">Телефон</div>
          <div className="form-input">
            <input
              style={getStyle('phone')}
              value={formData.phone}
              onChange={(e) => handleInputChange('phone', e.target.value)}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-label">Пошта *</div>
          <div className="form-input">
            <input
              style={getStyle('email')}
              value={formData.email}
              onChange={(e) => handleInputChange('email', e.target.value.trim())}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-label">Роль *</div>
          <div className="form-input">
            <select
              style={getStyle('role')}
              value={localState.role}
              onChange={handleRoleChange}
            >
              {config.roles.map((item, i) => (
                <option key={item} value={item}>{config.rolesName[i]}</option>
              ))}
            </select>
          </div>
        </div>

        {roles_kg.includes(localState.role) ? (
          <div className="form-row">
            <div className="form-label">Id ДНЗ *</div>
            <div className="form-input">
              <input
                style={getStyle('area')}
                value={formData.area}
                onChange={(e) => {
                  handleInputChange('area', e.target.value);
                  setLocalState(prev => ({ ...prev, area: e.target.value }));
                }}
              />
            </div>
          </div>
        ) : (
          <div className="form-row">
            <div className="form-label">Район *</div>
            <div className="form-input">
              <select
                style={getStyle('area')}
                value={localState.area}
                onChange={(e) => {
                  handleInputChange('area', e.target.value);
                  setLocalState(prev => ({ ...prev, area: e.target.value }));
                }}
              >
                <option value="Київ">Київ</option>
                {config.districts.map(item => (
                  <option key={item} value={item}>{item}</option>
                ))}
              </select>
            </div>
          </div>
        )}

        <div className="form-row">
          <div className="form-label">Права *</div>
          <div className="form-input">
            <input
              style={getStyle('grant')}
              value={formData.grant}
              onChange={(e) => handleInputChange('grant', e.target.value)}
              placeholder="CRUD"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-label">Дозволити авторизацію за:</div>
          <div className="form-input">
            <select
              style={getStyle('privelegesAuthType')}
              value={localState.privelegesAuthType}
              onChange={(e) => {
                handleInputChange('privelegesAuthType', e.target.value);
                setLocalState(prev => ({ ...prev, privelegesAuthType: e.target.value }));
              }}
            >
              {Object.keys(config.authType).map(el => (
                <option key={el} value={el}>{config.authType[el]}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-label">Активний</div>
          <div className="form-input">
            <input
              type="checkbox"
              checked={formData.isActive}
              onChange={(e) => handleInputChange('isActive', e.target.checked)}
            />
          </div>
        </div>

        <div className="form-actions">
          <button type="button" className="btn-primary" onClick={handleSubmit}>
            {action === 'add' ? 'Додати' : 'Зберегти'}
          </button>
          <button type="button" className="btn-secondary" onClick={onClose}>
            Скасувати
          </button>
        </div>
      </div>

      <style jsx>{`
        .staff-form {
          padding: 20px;
        }
        .form-section {
          margin-bottom: 20px;
        }
        .form-row {
          display: flex;
          align-items: center;
          margin-bottom: 15px;
        }
        .form-label {
          width: 200px;
          font-weight: 500;
        }
        .form-input input,
        .form-input select {
          width: 100%;
          padding: 8px;
          border: 1px solid #ddd;
          border-radius: 4px;
        }
        .form-input input[type="checkbox"] {
          width: auto;
        }
        .form-actions {
          display: flex;
          gap: 10px;
          margin-top: 20px;
        }
        .btn-primary, .btn-secondary {
          padding: 10px 20px;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }
        .btn-primary {
          background: #007bff;
          color: white;
        }
        .btn-secondary {
          background: #6c757d;
          color: white;
        }
      `}</style>
    </div>
  );
};

export default AddEditUser;